import { Component, inject } from '@angular/core';
import { LocalCsvService } from '../../../../../../../services/local-csv/local-csv.service';

@Component({
  selector: 'csv-phone-duplicates',
  standalone: true,
  imports: [],
  templateUrl: './duplicates.component.html',
  styleUrl: './duplicates.component.css',
})
export class DuplicatesComponent {
  constructor() {}
  localCSVService = inject(LocalCsvService)


  get duplicates(){
    return this.localCSVService.getDuplicates
  }
}
